<script>
    import { createEventDispatcher, onMount } from 'svelte';
    import { browser } from '$app/environment';
    import { afterNavigate } from '$app/navigation';
    import Button from './Button.svelte';

    let className = '';
    export {className as class};

    const dispatch = createEventDispatcher();
    
    let buttonElement;
    let footerOffset = -200; // Hidden by default
    let footerElement = null;
    let heroElement = null;

    function openFeedbackModal() {
        dispatch('openFeedback');
    }

    function updateElementReferences() {
        if (!browser) return;
        footerElement = document.querySelector('#page-footer');
        heroElement = document.querySelector('#page-hero');
    }

    function updateButtonPosition() {
        if (!browser || !buttonElement) return;

        const viewportHeight = window.innerHeight;
        let offset = 16; // Default visible position (1rem)
        
        // Check footer overlap
        if (footerElement) {
            const footerRect = footerElement.getBoundingClientRect();
            const footerTop = footerRect.top;
            
            if (footerTop < viewportHeight) {
                // Position button above footer with padding
                offset = Math.max(offset, viewportHeight - footerTop + 16);
            }
        }
        
        // Check hero overlap  
        if (heroElement) {
            const heroRect = heroElement.getBoundingClientRect();
            const heroBottom = heroRect.bottom;
            
            if (heroBottom > 0) {
                // Position button below hero with padding
                const heroOverlap = heroBottom + 16; // 16px padding
                const buttonFromBottom = viewportHeight - heroOverlap;
                
                if (buttonFromBottom < 80) { // Approximate button height + padding
                    offset = -200; // Hide button
                }
            }
        }
        
        footerOffset = offset;
    }

    // Update element references after navigation
    afterNavigate(() => {
        updateElementReferences();
    });

    onMount(() => {
        if (!browser) return;

        // Initial setup
        updateElementReferences();
        updateButtonPosition();

        const handleScroll = () => updateButtonPosition();
        window.addEventListener('scroll', handleScroll, { passive: true });
        
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    });

</script>

<div 
    bind:this={buttonElement}
    class="fixed right-4 z-40 bg-black/50 hover:bg-black rounded-xl transition-all duration-200 {className}"
    style="bottom: {footerOffset}px"
>
    <Button outline primary on:click={openFeedbackModal}>Feedback</Button>
</div>
